import React from 'react';
import ProfilePageHeader from './components/ProfilePageHeader/ProfilePageHeader';
import AppBar from '../../base/components/AppBar/AppBar';
import ProfilePageContent from './components/ProfilePageContent/ProfilePageContent';

export default props => (
    <div>
      <AppBar {...props} />
      <ProfilePageHeader />
      <ProfilePageContent />
    </div>
  );
